<template>
  <div>
    Channel manager
  </div>
</template>

<script>
export default {
  name: "ChannelManager"
}
</script>

<style scoped>

</style>
